import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Gana from "../../../assets/shortlist_23/gana.png";
import Sola from "../../../assets/shortlist_23/sola.png";
import Sadiq from "../../../assets/shortlist_23/sadiq.png";
import Karo from "../../../assets/shortlist_23/karo.png";

const communityNominees = [
  {
    name: "Kangyang Gana",
    title: "Claire Aid Foundation",
    imgpath: Gana,
  },
  {
    name: "Sola Fanawopo",
    title: "Igbajo Development Association",
    imgpath: Sola,
  },
  {
    name: "Abubakar Sadiq Muazu",
    title: "Centre For Advocacy, Transparency And Accountability Initiative",
    imgpath: Sadiq,
  },
  {
    name: "Karo Omu",
    title: "Sanitary Aid Initiative",
    imgpath: Karo,
  },
];

const CommunityNominees = () => {
  return (
    <Grid
      item
      xs={12}
      md={12}
      marginTop={{ xs: "10%", sm: "3%" }}
      data-aos={"fade-up"}
    >
      <Typography
        variant={"h5"}
        fontWeight={400}
        paddingBottom={"2%"}
        color={"#049593"}
      >
        Award for Community Service (Shortlisted Nominees)
      </Typography>
      <Grid item xs={12} md={12} display={"flex"} flexWrap={"wrap"}>
        {communityNominees.map((nominate, index) => {
          const { name, title, imgpath } = nominate;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
            >
              <Card
                sx={{
                  maxWidth: 260,
                  height: "100%",
                  borderTop: "10px solid #D7A036",
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Avatar
                      alt={name}
                      src={imgpath}
                      sx={{ width: 126, height: 126 }}
                    />
                    <Typography
                      gutterBottom
                      variant="h6"
                      color={"#004165"}
                      component="div"
                      textAlign={"center"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#049593"
                      paragraph
                      textAlign={"center"}
                    >
                      {title}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default CommunityNominees;
